import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BLOG_POSTS } from "@/lib/blogPosts";

export default function Blog() {
  return (
    <div className="pt-28 md:pt-32 pb-24 min-h-screen" data-testid="page-blog">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="rule-gold" /><span className="eyebrow">Resources · Blog</span>
        </div>
        <div className="grid md:grid-cols-12 gap-8 items-end">
          <h1 className="md:col-span-8 serif text-5xl md:text-7xl leading-[0.95] tracking-tight">
            Field notes for <em className="italic text-[#b8892b]">Americans in France</em>.
          </h1>
          <p className="md:col-span-4 text-lg text-[#4a5570] leading-relaxed">
            Guides, checklists, and honest breakdowns from someone who has lived both systems.
          </p>
        </div>

        <div className="mt-16 space-y-6" data-testid="blog-list">
          {BLOG_POSTS.map((post, i) => (
            <motion.article
              key={post.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="group"
              data-testid={`blog-card-${post.slug}`}
            >
              <Link to={`/blog/${post.slug}`} className="grid md:grid-cols-12 gap-6 md:gap-10 items-center border-t border-[#0d1b3e]/15 pt-8 pb-2">
                <div className="md:col-span-4 aspect-[4/3] overflow-hidden bg-[#0d1b3e]">
                  <img src={post.hero} alt={post.title} loading="eager"
                    className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
                </div>
                <div className="md:col-span-8">
                  <div className="text-[10px] uppercase tracking-[0.22em] text-[#b8892b]">
                    {post.tags.join(" · ")} · {post.read}
                  </div>
                  <h2 className="serif text-3xl md:text-4xl text-[#0d1b3e] mt-3 leading-tight group-hover:text-[#b8892b] transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-[#4a5570] mt-3 leading-relaxed max-w-2xl">{post.excerpt}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-sm uppercase tracking-[0.16em] text-[#0d1b3e] group-hover:text-[#b8892b]">
                    Read the guide <ArrowUpRight size={14} />
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
}
